{
  "aiChat.notFound": "Tato konverzace už neexistuje.",
  "apiToken.create.button": "Nový token",
  "apiToken.create.cancel": "Zavřít",
  "apiToken.create.error": "Nepodařilo se vytvořit token",
  "apiToken.create.submit": "Vytvořit",
  "apiToken.create.success": "Token byl vytvořen",
  "apiToken.create.title": "Nový API token",
  "apiToken.edit.button": "Upravit",
  "apiToken.edit.cancel": "Zavřít",
  "apiToken.edit.error": "Nepodařilo se uložit změny",
  "apiToken.edit.scopeCancel": "Zrušit",
  "apiToken.edit.scopeConfirm": "Změnit",
  "apiToken.edit.scopeConfirmDescription": "Partner, který token používá, uvidí od této chvíle jiná zařízení.",
  "apiToken.edit.scopeConfirmTitle": "Opravdu chcete změnit přiřazení tokenu?",
  "apiToken.edit.submit": "Uložit",
  "apiToken.edit.success": "Uloženo",
  "apiToken.edit.title": "Upravit API token",
  "apiToken.form.name": "Název",
  "apiToken.form.note": "Poznámka",
  "apiToken.form.scope": "Token platí pro",
  "apiToken.form.scopeDevice": "Zařízení",
  "apiToken.form.scopeGroup": "Skupinu",
  "apiToken.remove.button": "Smazat",
  "apiToken.remove.cancel": "Zrušit",
  "apiToken.remove.confirm": "Smazat",
  "apiToken.remove.confirmDescription": "Partner, který token používá, okamžitě ztratí přístup k API. Akce je nevratná.",
  "apiToken.remove.confirmTitle": "Opravdu chcete smazat token?",
  "apiToken.remove.error": "Chyba při mazání tokenu",
  "apiToken.remove.success": "Token smazán",
  "apiToken.value.copied": "Token zkopírován do schránky",
  "apiToken.value.copy": "Zkopírovat token",
  "apiToken.value.hide": "Skrýt token",
  "apiToken.value.show": "Zobrazit token",
  "apiTokenList.createdAt": "Vytvořen",
  "apiTokenList.empty": "Žádné tokeny",
  "apiTokenList.name": "Název",
  "apiTokenList.title": "API tokeny",
  "apiTokenList.token": "Token",
  "apiTokens.table.createdAt": "Vytvořen",
  "apiTokens.table.name": "Název",
  "apiTokens.table.note": "Poznámka",
  "apiTokens.table.scope": "Přiřazeno",
  "apiTokens.table.scopeDevice": "Zařízení: {name}",
  "apiTokens.table.scopeGroup": "Skupina: {name}",
  "apiTokens.table.token": "Token",
  "apiTokens.title": "API tokeny",
  "auth.email": "Email",
  "auth.forgotten.button": "Poslat email pro změnu hesla",
  "auth.forgotten.link": "Zapomenuté heslo",
  "auth.magicLink.button": "Poslat magic link",
  "auth.magicLink.link": "Poslat magic link",
  "auth.password": "Heslo",
  "auth.signIn.button": "Přihlásit se",
  "auth.signIn.link": "Máte účet? Přihlásit se",
  "auth.signUp.button": "Registrovat",
  "auth.signUp.link": "Nemáte účet? Registrovat",
  "auth.socialProvider": "Přihlásit se přes '{{provider}}'",
  "auth.update.button": "Změnit heslo",
  "auth.update.passwordLabel": "Nové heslo",
  "authResetPassword.confirm": "Potvrzení hesla",
  "authResetPassword.error": "Při změně hesla došlo k chybě.",
  "authResetPassword.password": "Heslo",
  "authResetPassword.submit": "Uložit",
  "authResetPassword.title": "Nastavte si prosím heslo",
  "authSetPassword.confirm": "Potvrzení hesla",
  "authSetPassword.error": "Nastala chyba při ukládání hesla",
  "authSetPassword.password": "Heslo",
  "authSetPassword.submit": "Uložit",
  "authSetPassword.title": "Nastavte si prosím heslo",
  "clientPortal.docs.links": "Odkazy",
  "clientPortal.docs.title": "Dokumentace",
  "clientPortal.docs.userWiki": "Uživatelská WIKI",
  "clientPortal.docs.wiki": "Wiki stránky",
  "clientPortal.docs.wikiInfo": "Obsahují detailní uživatelský návod na nastavení Infigy společně s podporovaným příslušenstvím jako je fve střídač, bojler, tepelné čerpadlo, chytrá zásuvka a jiné.",
  "clientPortal.title": "Klientská sekce",
  "companySelect.label": "Firma",
  "companySignUp.confirmation.close": "Zavřít",
  "companySignUp.confirmation.text": "Vaše žádost byla úspěšně odeslána. Po ověření žádosti a přiřazení servisního hesla Vás kontaktujeme.",
  "companySignUp.confirmation.title": "Potvrzení",
  "companySignUp.error": "Nepodařilo se vytvořit žádost",
  "companySignUp.form.back": "Zpět",
  "companySignUp.form.companyName": "Název firmy",
  "companySignUp.form.note": "Poznámka",
  "companySignUp.form.submit": "Potvrdit",
  "companySignUp.form.title": "Žádost o vytvoření instalačního účtu",
  "companySignUp.noDevice.close": "Zavřít",
  "companySignUp.noDevice.isCompany": "Jsem instalační firma",
  "companySignUp.noDevice.text": "K vašemu účtu dosud nebylo přiřazeno žádné zařízení. Vyčkejte na přiřazení od instalační firmy.",
  "companySignUp.noDevice.title": "Žádné přiřazené zařízení",
  "companySignUp.success": "Žádost byla vytvořena",
  "dashboard.alert.avgCharge": "Průměrné nabití: {value}%",
  "dashboard.alert.avgTemperature": "Průměrná teplota: {value}",
  "dashboard.alert.extraOverflow": "Přetok \"navíc\" za poslední 4 dny: {value} kWh",
  "dashboard.alert.lastTwoDays": "Poslední dva dny: {value} kWh",
  "dashboard.alert.overflows": "Přetoky: {value} kWh",
  "dashboard.alert.setTemperature": "Nastavená teplota: {value}",
  "dashboard.betaInfo": "Aktuálně je dashboard v BETA režimu, což znamená, že můžete být mezi prvními, kteří jej vyzkouší. V budoucnu plánujeme tuto funkcionalitu zpoplatnit, ale v rámci BETA testování můžete využít všechny její výhody zdarma. Budeme rádi za jakoukoli zpětnou vazbu na {email}.",
  "dashboard.chart.actualSoc": "SOC",
  "dashboard.chart.consumption": "Spotřeba",
  "dashboard.chart.minimalSoc": "Minimalní SOC",
  "dashboard.chart.overflow": "Přetok",
  "dashboard.chart.photovoltaicsProduction": "Výroba",
  "dashboard.chart.temperature": "Teplota",
  "dashboard.chart.temperatureSetting": "Nastavená teplota",
  "dashboard.col.battery": "Baterie",
  "dashboard.col.batteryUndercharge": "Podbití baterie",
  "dashboard.col.boiler": "Boiler",
  "dashboard.col.criticalBatteryUndercharge": "Hrubé podbití baterie",
  "dashboard.col.device": "Zařízení",
  "dashboard.col.heatPumpCommunication": "Komunikace s TČ",
  "dashboard.col.inverterCommunication": "Komunikace se střídačem",
  "dashboard.col.maxOverflow": "Max přetoky",
  "dashboard.col.maxOverflowTotal": "Celkem: {count}",
  "dashboard.col.nighttimeOverflows": "Noční přetoky",
  "dashboard.col.photovoltaics": "Výroba FVE",
  "dashboard.deviceDetail.battery": "Baterie",
  "dashboard.deviceDetail.compact": "Kompaktní",
  "dashboard.deviceDetail.detailed": "Detailní",
  "dashboard.deviceDetail.energy": "Energie",
  "dashboard.deviceDetail.layoutLabel": "Zobrazení",
  "dashboard.deviceDetail.loadError": "Při načítání došlo k chybě",
  "dashboard.deviceDetail.waterHeater": "Teplá voda",
  "dashboard.filters.alert": "Upozornění",
  "dashboard.filters.all": "Vše",
  "dashboard.filters.ignored": "Ignorováno",
  "dashboard.filters.operational": "V pořádku",
  "dashboard.filters.status": "Stav",
  "dashboard.filters.unknown": "Neznámé",
  "dashboard.loadError": "Při načítání došlo k chybě",
  "dashboard.stats.operational": "V pořádku",
  "dashboard.stats.totalDevices": "Zařízení celkem",
  "dashboard.stats.withAlerts": "S upozorněním",
  "device.detail.createdAt": "Vytvořen",
  "device.detail.deviceId": "ID zařízení",
  "device.detail.email": "Email",
  "device.detail.firstUserAssignedAt": "První uživatel přiřazen (datum instalace)",
  "device.detail.groupEmail": "Email",
  "device.detail.groupName": "Název",
  "device.detail.groups": "Skupiny",
  "device.detail.internalIp": "Interní IP",
  "device.detail.notifications": "Notifikace",
  "device.detail.serialNumber": "Výrobní číslo",
  "device.detail.userEmail": "Email",
  "device.detail.users": "Uživatelé",
  "device.events.loadError": "Při načítání došlo k chybě",
  "device.events.showAll": "Zobrazit vše",
  "device.events.title": "Seznam událostí",
  "device.export.cancel": "Zrušit",
  "device.export.error": "Nepodařilo se exportovat zařízení",
  "device.export.formatLabel": "Formát exportu",
  "device.export.noVariables": "Zadejte alespoň jednu proměnnou",
  "device.export.submit": "Exportovat",
  "device.export.title": "Exportovat zařízení",
  "device.export.tooltip": "Exportovat proměnné ze všech zařízení",
  "device.export.variablesLabel": "Proměnné pro export (oddělené čárkou)",
  "device.general": "Obecné",
  "device.labels.clear": "Zrušit změny",
  "device.labels.error": "Nepodařilo se uložit štítky",
  "device.labels.save": "Uložit změny",
  "device.labels.success": "Štítky byly uloženy",
  "device.labels.title": "Štítky",
  "device.missingAirtableId": "Chybí Airtable ID",
  "device.offline": "Offline",
  "device.open": "Otevřít",
  "device.plusActive": "Infigy Plus aktivní",
  "device.restart.action": "Restartovat",
  "device.restart.cancel": "Zrušit",
  "device.restart.confirm": "Restartovat",
  "device.restart.confirmDescription": "Opravdu chcete restartovat zařízení? Zařízení bude nedostupné na několik minut.",
  "device.restart.confirmTitle": "Potvrdit restart zařízení",
  "device.restart.error": "Chyba při restartování: {message}",
  "device.restart.success": "Zařízení se restartuje",
  "device.select.empty": "Žádné zařízení nenalezeno",
  "device.select.label": "Zařízení",
  "device.select.searchHint": "Zadejte alespoň {count} znaky pro vyhledání zařízení",
  "device.title": "Zařízení",
  "device.update.action": "Aktualizovat",
  "device.update.adminDuration": "Tato operace může trvat několik minut.",
  "device.update.betaNotice": "Tato funkce je aktuálně v beta režimu. Doporučujeme aktualizovat během pracovní doby pro případ potřeby podpory za situace, kdy se aktualizace nezdaří. Děkujeme za pochopení.",
  "device.update.branchHint": "Pokud ponecháte pole prázdné, použije se aktuální branche zařízení. Při změně se ujistěte, že daná branch existuje.",
  "device.update.branchLabel": "Změna branche",
  "device.update.cancel": "Zrušit",
  "device.update.confirm": "Aktualizovat",
  "device.update.confirmTitle": "Opravdu chcete aktualizovat zařízení?",
  "device.update.skipAppRunningCheck": "Ignorovat, pokud aplikace neběží",
  "device.update.startError": "Chyba při spuštění aktualizace zařízení",
  "device.updateStatus.failed": "Chyba",
  "device.updateStatus.pending": "Běží",
  "device.updateStatus.queued": "Ve frontě",
  "device.updateStatus.success": "Dokončeno",
  "device.vpnSessions.connected": "Připojeno",
  "device.vpnSessions.disconnected": "Odpojeno",
  "device.vpnSessions.empty": "Zatím nejsou zaznamenána žádná připojení.",
  "device.vpnSessions.online": "Online",
  "device.vpnSessions.stillConnected": "Stále připojeno",
  "device.vpnSessions.subtitle": "Zobrazeno posledních {count} připojení.",
  "device.vpnSessions.title": "Historie připojení",
  "deviceBackups.confirmDescription": "Opravdu chcete vytvořit novou zálohu zařízení?",
  "deviceBackups.confirmTitle": "Vytvořit zálohu?",
  "deviceBackups.create": "Vytvořit zálohu",
  "deviceBackups.download": "Stáhnout zálohu",
  "deviceBackups.downloadUrlError": "Nepodařilo se získat odkaz ke stažení",
  "deviceBackups.restore": "Obnovit ze zálohy",
  "deviceBackups.show": "Zobrazit zálohy",
  "deviceBackups.table.date": "Datum zálohy",
  "deviceBackups.table.size": "Velikost",
  "deviceBackups.title": "Zálohy",
  "deviceBackups.triggerError": "Chyba při plánování zálohy: {message}",
  "deviceBackups.triggerSuccess": "Záloha byla úspěšně naplánována",
  "deviceNotifications.count": "Počet notifikací",
  "deviceNotifications.lastNotification": "Poslední notifikace",
  "deviceNotifications.loadError": "Chyba při načítání notifikací",
  "deviceRestore.dialog.backupLabel": "Záloha",
  "deviceRestore.dialog.cancel": "Zavřít",
  "deviceRestore.dialog.confirmDescription": "Databáze zařízení {deviceName} bude přepsána zálohou {backupName}. Aplikace bude na několik minut zastavena. Výrobní číslo zařízení bude zachováno.",
  "deviceRestore.dialog.confirmTitle": "Obnovit zálohu?",
  "deviceRestore.dialog.error": "Nepodařilo se spustit obnovení zálohy: {message}",
  "deviceRestore.dialog.noBackups": "Žádné zálohy",
  "deviceRestore.dialog.serialMissing": "U zařízení neznáme výrobní číslo. Obnovení se pokusí načíst ho ze zařízení, a pokud ho nenajde, zůstane po obnovení výrobní číslo ze zálohy — zkontrolujte ho prosím ručně.",
  "deviceRestore.dialog.serialPreserved": "Výrobní číslo {serialNumber} bude po obnovení vráceno zpět.",
  "deviceRestore.dialog.submit": "Obnovit",
  "deviceRestore.dialog.title": "Obnovit zálohu",
  "deviceRestore.dialog.warning": "Databáze zařízení {deviceName} bude přepsána vybranou zálohou. Aplikace bude na několik minut zastavena a původní databáze zůstane na zařízení odložená jako db.sqlite.pre-restore-*.",
  "deviceRestoreDetail.backupName": "Záloha",
  "deviceRestoreDetail.createdAt": "Vytvořeno",
  "deviceRestoreDetail.device": "Zařízení",
  "deviceRestoreDetail.loadError": "Chyba při načítání detailu obnovení zálohy",
  "deviceRestoreDetail.logs": "Logy",
  "deviceRestoreDetail.sourceDevice": "Zdrojové zařízení",
  "deviceRestoreDetail.startedBy": "Spustil",
  "deviceRestoreDetail.status": "Stav",
  "deviceRestoreDetail.title": "Obnovení zálohy zařízení",
  "deviceRestoreDetail.titleSegment": "Obnovení zálohy",
  "deviceRestoreDetail.updatedAt": "Poslední změna",
  "deviceSubscriptions.create": "Založit předplatné",
  "deviceSubscriptions.createError": "Chyba při vytváření předplatného",
  "deviceSubscriptions.empty": "Žádná předplatná",
  "deviceSubscriptions.manage": "Spravovat předplatné",
  "deviceSubscriptions.manageError": "Chyba při otvírání správy předplatného",
  "deviceSubscriptions.table.createdAt": "Datum vytvoření",
  "deviceSubscriptions.table.status": "Status",
  "deviceUpdateDetail.createdAt": "Vytvořeno",
  "deviceUpdateDetail.device": "Zařízení",
  "deviceUpdateDetail.loadError": "Chyba při načítání detailu aktualizace zařízení",
  "deviceUpdateDetail.logs": "Logy",
  "deviceUpdateDetail.startedBy": "Spustil",
  "deviceUpdateDetail.status": "Stav",
  "deviceUpdateDetail.title": "Aktualizace zařízení",
  "deviceUpdateDetail.titleSegment": "Aktualizace",
  "deviceUpdateDetail.updatedAt": "Poslední změna",
  "deviceUpdateList.colDevice": "Zařízení",
  "deviceUpdateList.colInternalIp": "Interní IP",
  "deviceUpdateList.colStartedBy": "Spustil",
  "deviceUpdateList.colStatus": "Stav",
  "deviceUpdateList.colUpdatedAt": "Poslední změna",
  "deviceUpdateList.confirm": "Aktualizovat",
  "deviceUpdateList.confirmTitle": "Aktualizace zařízení",
  "deviceUpdateList.deviceIdsLabel": "ID zařízení (oddělené čárkou)",
  "deviceUpdateList.deviceOffline": "Zařízení je offline",
  "deviceUpdateList.loadError": "Chyba při načítání aktualizací zařízení",
  "deviceUpdateList.openDevice": "Otevřít zařízení",
  "deviceUpdateList.title": "Aktualizace zařízení",
  "deviceUpdateList.titleSegment": "Aktualizace",
  "deviceUpdateSource.device": "ze zařízení",
  "deviceUpdateSource.mcp": "Figgy",
  "deviceUpdateSource.portal": "z portálu",
  "deviceUpdateSource.unknown": "",
  "devices.columns.title": "Zobrazené sloupce",
  "devices.filters.openAlert": "Otevřený alert",
  "devices.head.createdAt": "Vytvořeno",
  "devices.head.device": "Zařízení",
  "devices.head.internalIp": "Interní IP",
  "devices.head.macAddress": "MAC adresa",
  "devices.head.onlineSince": "Online",
  "devices.head.serialNumber": "Výrobní číslo",
  "devices.head.status": "Status",
  "devices.head.version": "Verze",
  "devices.open": "Otevřít",
  "devices.plusActive": "Infigy Plus aktivní",
  "devices.softwareVersion": "Verze software",
  "devices.sort.firstUserAssignedAt": "Přiřazení prvního uživatele",
  "devices.sort.name": "Abecedně",
  "devices.sort.title": "Řazení",
  "devices.title": "Zařízení",
  "devices.update": "Aktualizovat",
  "devices.whyNoDevices": "Proč nevidím žádné zařízení?",
  "digest.calls.answered": "Odbavené hovory",
  "digest.calls.average": "Průměrná délka odbaveného hovoru (min)",
  "digest.calls.caller": "Volající",
  "digest.calls.count": "Hovorů",
  "digest.calls.heading": "Hovory",
  "digest.calls.installsPeriod": "Instalace za období",
  "digest.calls.installsTotal": "Instalace celkem",
  "digest.calls.minutes": "Minut",
  "digest.calls.missed": "Zmeškané hovory",
  "digest.calls.operator": "Operátor",
  "digest.calls.operators": "Nejvytíženější operátoři",
  "digest.calls.time": "Provoláno",
  "digest.calls.topCallers": "Nejaktivnější volající",
  "digest.calls.totalTime": "Provoláno (h:mm)",
  "digest.calls.uniqueCallers": "Unikátních volajících",
  "digest.figgy.active": "S aktivitou",
  "digest.figgy.activeConversations": "Konverzací s aktivitou",
  "digest.figgy.bySource": "Podle zdroje",
  "digest.figgy.byUser": "Nejaktivnější uživatelé",
  "digest.figgy.conversations": "Konverzací",
  "digest.figgy.errors": "Chybných odpovědí",
  "digest.figgy.fromFiggy": "Odpovědí",
  "digest.figgy.heading": "Figgy",
  "digest.figgy.messages": "Zpráv celkem",
  "digest.figgy.messagesFromFiggy": "Odpovědí od Figgy",
  "digest.figgy.messagesToFiggy": "Dotazů na Figgy",
  "digest.figgy.newConversations": "Nových konverzací",
  "digest.figgy.source": "Zdroj",
  "digest.figgy.source.gmail": "Gmail",
  "digest.figgy.source.portal": "Aplikace",
  "digest.figgy.source.routine": "Rutiny",
  "digest.figgy.source.slack": "Slack",
  "digest.figgy.source.user": "Web",
  "digest.figgy.toFiggy": "Dotazů",
  "digest.figgy.user": "Uživatel",
  "digest.from": "Od",
  "digest.installs.company": "Firma",
  "digest.installs.count": "Instalací",
  "digest.installs.heading": "Instalace",
  "digest.installs.topCompanies": "Nejaktivnější firmy",
  "digest.installs.total": "Instalací celkem",
  "digest.load": "Načíst",
  "digest.loading": "Načítám přehled. U delších období to může trvat i dvě minuty — čtou se všechny e-maily za období.",
  "digest.mail.correspondents": "Unikátních protistran",
  "digest.mail.excluded": "Vyřazeno jako automatické",
  "digest.mail.heading": "E-maily",
  "digest.mail.long": "Dlouhá",
  "digest.mail.messageCount": "Zpráv",
  "digest.mail.messageShare": "% zpráv",
  "digest.mail.name": "Jméno",
  "digest.mail.new": "Jednorázová",
  "digest.mail.perThread": "Zpráv na vlákno",
  "digest.mail.received": "Přijaté e-maily",
  "digest.mail.sender": "Odesílatel",
  "digest.mail.sent": "Odeslané e-maily",
  "digest.mail.short": "Krátká",
  "digest.mail.threadCount": "Vláken",
  "digest.mail.threadShare": "% vláken",
  "digest.mail.threadType": "Typ vlákna",
  "digest.mail.threads": "Vlákna (dlouhé = {min}+ zpráv)",
  "digest.mail.topSenders": "Nejaktivnější odesílatelé",
  "digest.period": "Období",
  "digest.periodLabel": "Období: {label} ({timeZone})",
  "digest.preset.custom": "Vlastní rozsah",
  "digest.preset.day": "Dnes",
  "digest.preset.last30d": "Posledních 30 dní",
  "digest.preset.last7d": "Posledních 7 dní",
  "digest.preset.lastMonth": "Minulý měsíc",
  "digest.preset.month": "Tento měsíc",
  "digest.preset.week": "Tento týden",
  "digest.preset.yesterday": "Včera",
  "digest.sectionUnavailable": "Sekce je nedostupná: {error}",
  "digest.title": "Přehled podpory",
  "digest.to": "Do (mimo)",
  "figgyChat.cancel": "Zrušit",
  "figgyChat.composer.aiDisclaimer": "AI může dělat chyby.",
  "figgyChat.composer.autoSend": "Hands-free",
  "figgyChat.composer.autoSendHint": "Hands-free: každá nadiktovaná věta se odešle sama, jakmile se odmlčíte",
  "figgyChat.composer.placeholder": "Napište zprávu…",
  "figgyChat.conversation.delete": "Smazat",
  "figgyChat.conversation.options": "Možnosti konverzace",
  "figgyChat.conversation.rename": "Přejmenovat",
  "figgyChat.conversation.untitled": "Nová konverzace",
  "figgyChat.delete.body": "Konverzace „{title}\" bude trvale smazána. Tuto akci nelze vrátit zpět.",
  "figgyChat.delete.confirm": "Smazat",
  "figgyChat.delete.title": "Smazat konverzaci?",
  "figgyChat.dictation.denied": "Přístup k mikrofonu byl odepřen.",
  "figgyChat.dictation.expired": "Diktování vypršelo. Zkuste to znovu.",
  "figgyChat.dictation.failed": "Diktování selhalo. Zkuste to znovu.",
  "figgyChat.dictation.notStarted": "Diktování se nepodařilo spustit.",
  "figgyChat.dictation.quota": "Vyčerpaná kvóta ElevenLabs.",
  "figgyChat.dictation.start": "Diktovat zprávu",
  "figgyChat.dictation.stop": "Ukončit diktování",
  "figgyChat.kit.announce.completed": "Odpověď dokončena",
  "figgyChat.kit.announce.started": "Figgy odpovídá",
  "figgyChat.kit.author.assistant": "Figgy",
  "figgyChat.kit.author.system": "Systém",
  "figgyChat.kit.author.user": "Vy",
  "figgyChat.kit.composer.aria": "Zpráva",
  "figgyChat.kit.composer.attach": "Přidat přílohu",
  "figgyChat.kit.composer.attachInput": "Nahrát soubor",
  "figgyChat.kit.composer.attachmentFallback": "Příloha",
  "figgyChat.kit.composer.removeAttachment": "Odebrat {fileName}",
  "figgyChat.kit.composer.send": "Odeslat zprávu",
  "figgyChat.kit.error": "Něco se pokazilo",
  "figgyChat.kit.header.settings": "Nastavení",
  "figgyChat.kit.landmark.composer": "Psaní zprávy",
  "figgyChat.kit.landmark.conversationList": "Konverzace",
  "figgyChat.kit.landmark.message": "Zpráva",
  "figgyChat.kit.landmark.messageActions": "Akce zprávy",
  "figgyChat.kit.landmark.messageList": "Seznam zpráv",
  "figgyChat.kit.landmark.thread": "Konverzace",
  "figgyChat.kit.list.search": "Hledat konverzace",
  "figgyChat.kit.loading": "Načítání…",
  "figgyChat.kit.message.copiedCode": "Zkopírováno",
  "figgyChat.kit.message.copy": "Kopírovat",
  "figgyChat.kit.message.copyCode": "Kopírovat kód",
  "figgyChat.kit.message.deleted": "Smazáno",
  "figgyChat.kit.message.edited": "Upraveno",
  "figgyChat.kit.message.reasoning": "Úvaha",
  "figgyChat.kit.message.reasoningStreaming": "Přemýšlím…",
  "figgyChat.kit.reconnect": "Znovu připojit",
  "figgyChat.kit.retry": "Zkusit znovu",
  "figgyChat.kit.status.cancelled": "Zrušeno",
  "figgyChat.kit.status.error": "Chyba",
  "figgyChat.kit.status.pending": "Čeká",
  "figgyChat.kit.status.read": "Přečteno",
  "figgyChat.kit.status.sending": "Odesílání",
  "figgyChat.kit.status.sent": "Odesláno",
  "figgyChat.kit.status.streaming": "Píše se",
  "figgyChat.kit.suggestions": "Navrhované dotazy",
  "figgyChat.kit.thread.empty": "Zatím žádné zprávy",
  "figgyChat.kit.thread.emptyHelper": "Začněte napsáním zprávy",
  "figgyChat.kit.thread.scrollToBottom": "Posunout dolů",
  "figgyChat.kit.thread.scrollToBottomWithCount": "Posunout dolů, {count, plural, one {# nová zpráva} few {# nové zprávy} other {# nových zpráv}}",
  "figgyChat.kit.thread.unread": "Nové zprávy",
  "figgyChat.kit.tool.approve": "Schválit",
  "figgyChat.kit.tool.awaitingApproval": "Čeká na schválení",
  "figgyChat.kit.tool.completed": "Dokončeno",
  "figgyChat.kit.tool.denied": "Zamítnuto",
  "figgyChat.kit.tool.deny": "Zamítnout",
  "figgyChat.kit.tool.failed": "Selhalo",
  "figgyChat.kit.tool.input": "Volání nástroje",
  "figgyChat.kit.tool.output": "Výsledek nástroje",
  "figgyChat.kit.tool.running": "Probíhá…",
  "figgyChat.kit.typing": "{count, plural, one {{names} píše} other {{names} píšou}}",
  "figgyChat.list.back": "Zpět na konverzace",
  "figgyChat.list.close": "Zavřít konverzace",
  "figgyChat.list.empty": "Zatím žádné konverzace",
  "figgyChat.list.open": "Otevřít konverzace",
  "figgyChat.newChat": "Nová konverzace",
  "figgyChat.rename.label": "Název",
  "figgyChat.rename.title": "Přejmenovat konverzaci",
  "figgyChat.save": "Uložit",
  "figgyChat.send.busy": "Figgy ještě odpovídá na předchozí zprávu. Chvíli počkejte a zkuste to znovu.",
  "figgyChat.send.failed": "Zprávu se nepodařilo odeslat. Zkuste to prosím znovu.",
  "figgyChat.send.lostContact": "Ztratili jsme spojení při čekání na odpověď. Může ještě dorazit — otevřete konverzaci za chvíli znovu.",
  "figgyChat.widget.ask": "Zeptat se Figgy",
  "figgyChat.widget.close": "Zavřít",
  "figgyChat.widget.exitFullscreen": "Zmenšit",
  "figgyChat.widget.fullscreen": "Na celou obrazovku",
  "figgyChat.widget.newChat": "Nová konverzace",
  "group.create.button": "Vytvořit skupinu",
  "group.create.cancel": "Zavřít",
  "group.create.conflict": "Skupina již s tímto emailem existuje, nelze vytvořit další skupinu se stejným emailem.",
  "group.create.emailLabel": "Email",
  "group.create.error": "Nepodařilo se vytvořit skupinu",
  "group.create.infoIdentification": "Skupina se identifikuje emailem, ale email neslouží pro přihlášení k zařízením ve skupině. Pro použití skupiny prosím přidejte první uživatele.",
  "group.create.infoSecurity": "Uživatel může mít stejný email jako skupina, ale cílem je, aby ideálně skupina obsahovala uživatele jednotlivých lidí, aby se zvýšila bezpečnost.",
  "group.create.nameLabel": "Název",
  "group.create.submit": "Vytvořit",
  "group.create.success": "Skupina byla vytvořena",
  "group.create.title": "Vytvořit skupinu",
  "group.detail.company": "Firma",
  "group.detail.createdAt": "Vytvořena",
  "group.detail.deviceAssignedAt": "Přiřazeno",
  "group.detail.deviceName": "Jméno",
  "group.detail.devices": "Zařízení",
  "group.detail.email": "E-mail",
  "group.detail.memberEmail": "E-mail",
  "group.detail.members": "Členové",
  "group.detail.name": "Jméno",
  "group.deviceCreate.cancel": "Zavřít",
  "group.deviceCreate.error": "Nepodařilo se přidat zařízení do skupiny",
  "group.deviceCreate.submit": "Přidat",
  "group.deviceCreate.success": "Zařízení přiřazeno do skupiny",
  "group.deviceCreate.title": "Přiřadit zařízení do skupiny",
  "group.deviceRemove.cancelButton": "Zrušit",
  "group.deviceRemove.confirmButton": "Odebrat",
  "group.deviceRemove.confirmTitle": "Opravdu chcete odebrat zařízení {deviceName} ze skupiny {groupName}?",
  "group.deviceRemove.deviceSettingsWarning": "Tato skupina byla přiřazena prostřednictvím nastavení zařízení. Pokud bude zařízení online, může být skupina automaticky znovu přiřazena.",
  "group.deviceRemove.error": "Došlo k chybě",
  "group.deviceRemove.success": "Zařízení úspěšně odebráno ze skupiny",
  "group.edit.button": "Upravit",
  "group.edit.cancel": "Zavřít",
  "group.edit.error": "Nepodařilo se uložit změny",
  "group.edit.nameLabel": "Jméno",
  "group.edit.submit": "Uložit",
  "group.edit.success": "Uloženo",
  "group.edit.title": "Upravit skupinu",
  "group.emailEdit.cancel": "Zavřít",
  "group.emailEdit.conflict": "Skupina s tímto e-mailem již existuje",
  "group.emailEdit.emailLabel": "E-mail",
  "group.emailEdit.error": "Nepodařilo se změnit e-mail",
  "group.emailEdit.submit": "Uložit",
  "group.emailEdit.success": "E-mail skupiny byl změněn",
  "group.emailEdit.title": "Změnit e-mail skupiny",
  "group.emailEdit.warning": "E-mail bude změněn pouze na portálu. Změňte ho také v nastavení všech zařízení ve skupině, jinak se při jejich synchronizaci může vytvořit nová skupina s původním e-mailem.",
  "group.remove.button": "Smazat skupinu",
  "group.remove.confirmDescription": "Opravdu chcete smazat tuto skupinu?",
  "group.remove.confirmTitle": "Smazat skupinu",
  "group.remove.error": "Nepodařilo se smazat skupinu",
  "group.remove.mustBeEmpty": "Skupina musí být prázdná",
  "group.remove.success": "Skupina byla úspěšně smazána",
  "group.sendEmail.button": "Odeslat email",
  "group.sendEmail.cancel": "Zavřít",
  "group.sendEmail.emailLabel": "Email firmy",
  "group.sendEmail.error": "Nepodařilo se odeslat email",
  "group.sendEmail.submit": "Potvrdit",
  "group.sendEmail.success": "Odesláno",
  "group.sendEmail.title": "Odeslání emailu zákazníkovi po úspěšném nastavení skupiny",
  "group.title": "Skupina",
  "group.userCreate.cancel": "Zavřít",
  "group.userCreate.error": "Nepodařilo se přidat uživatele do skupiny",
  "group.userCreate.submit": "Přidat",
  "group.userCreate.success": "Uživatel přiřazen do skupiny",
  "group.userCreate.title": "Přiřadit uživatele do skupiny",
  "group.userRemove.cancelButton": "Zrušit",
  "group.userRemove.confirmButton": "Odebrat",
  "group.userRemove.confirmTitle": "Opravdu chcete odebrat uživatele {email} ze skupiny {groupName}?",
  "group.userRemove.error": "Došlo k chybě",
  "group.userRemove.success": "Uživatel úspěšně odebrán ze skupiny",
  "groupSelect.label": "Skupina",
  "groups.table.company": "Firma",
  "groups.table.createdAt": "Vytvořena",
  "groups.table.devices": "Zařízení",
  "groups.table.email": "E-mail",
  "groups.table.name": "Jméno",
  "groups.table.users": "Uživatelů",
  "groups.title": "Skupiny",
  "internalError.back": "Zpět na úvodní stránku",
  "internalError.text": "Něco se pokazilo na naší straně.{br}Kdyby chyba přetrvala, neváhejte se na nás obrátit na {email}",
  "internalError.title": "Došlo k chybě",
  "labels.create.error": "Chyba při vytváření štítku",
  "labels.create.success": "Štítek byl úspěšně vytvořen",
  "labels.loadError": "Chyba při načítání štítků",
  "labels.newLabel": "Nový štítek",
  "labels.remove.confirmTitle": "Opravdu chcete odstranit tento štítek?",
  "labels.remove.error": "Chyba při odstraňování štítku",
  "labels.remove.success": "Štítek byl úspěšně odstraněn",
  "labels.save": "Uložit štítek",
  "labels.table.name": "Jméno",
  "labels.table.type": "Typ",
  "labels.type.private": "Soukromý",
  "labels.type.public": "Veřejný",
  "labelsSelect.close": "Zavřít",
  "labelsSelect.label": "Štítky",
  "labelsSelect.management": "Správa štítků",
  "labelsSelect.managementTitle": "Správa štítků",
  "layout.me.signOut": "Odhlásit se",
  "mainLayout.energyTalk": "Připojte se 28.5.2025 na {link}",
  "me.adminSettings": "Nastavení administrátora",
  "me.apiTokens": "API tokeny",
  "me.apiTokensLink": "Spravovat API tokeny",
  "me.changePassword": "Změna hesla",
  "me.devMode": "Vývojářský režim",
  "me.email": "Email",
  "me.language": "Jazyk",
  "me.title": "Uživatelský účet",
  "mqttCloud.tab.credentials": "Přihlašovací údaje",
  "mqttCloud.tab.online": "Online",
  "mqttConnected.load": "Načíst online zařízení",
  "mqttConnected.loadError": "Nepodařilo se načíst online zařízení",
  "mqttConnected.online": "Online",
  "mqttUsers.createError": "Chyba při vytváření",
  "mqttUsers.created": "Vytvořeno",
  "mqttUsers.detail.cancel": "Zavřít",
  "mqttUsers.detail.loadError": "Chyba při načítání",
  "mqttUsers.detail.note": "Poznámka",
  "mqttUsers.detail.password": "Heslo",
  "mqttUsers.detail.submit": "Uložit",
  "mqttUsers.detail.title": "Detail uživatele",
  "mqttUsers.detail.user": "Uživatel",
  "mqttUsers.loadError": "Chyba při načítání",
  "mqttUsers.remove.cancel": "Zrušit",
  "mqttUsers.remove.confirm": "Smazat",
  "mqttUsers.remove.confirmDescription": "Tato akce je nevratná.",
  "mqttUsers.remove.confirmTitle": "Opravdu chcete smazat uživatele?",
  "mqttUsers.remove.error": "Chyba při mazání uživatele",
  "mqttUsers.remove.success": "Uživatel smazán",
  "mqttUsers.saveError": "Chyba při ukládání",
  "mqttUsers.saved": "Uloženo",
  "mqttUsers.table.createdAt": "Vytvořeno",
  "mqttUsers.table.note": "Poznámka",
  "mqttUsers.table.password": "Heslo",
  "mqttUsers.table.user": "Uživatel",
  "nav.client": "Klientská sekce",
  "nav.dashboard": "Dashboard",
  "nav.deviceUpdates": "Aktualizace zařízení",
  "nav.devices": "Zařízení",
  "nav.groups": "Skupiny",
  "nav.partner": "Partnerská sekce",
  "nav.users": "Uživatelé",
  "pagination.rowsPerPage": "Na stránku",
  "partner.company.basicInfo": "Základní informace",
  "partner.company.loading": "Načítání",
  "partner.company.name": "Název firmy: {name}",
  "partner.company.serviceEmail": "Servisní email firmy: {email}",
  "partner.company.servicePassword": "Servisní heslo: {value}",
  "partner.company.showPassword": "Zobrazit heslo",
  "partner.company.title": "Firemní údaje",
  "partner.contact.hours": "9-16 hodin",
  "partner.contact.serviceEmail": "Servisní email",
  "partner.contact.serviceLine": "Servisní linka",
  "partner.contact.title": "Kontaktujte nás",
  "partner.contact.weekdays": "Všední dny",
  "partner.docs.codex": "Náš kodex",
  "partner.docs.links": "Odkazy",
  "partner.docs.techWiki": "Technická WIKI",
  "partner.docs.title": "Dokumentace",
  "partner.docs.userWiki": "Uživatelská WIKI",
  "partner.docs.wiki": "Wiki stránky",
  "partner.docs.wikiInfo": "Obsahují detailní servisní návod na zprovoznění Infigy společně s podporovaným příslušenstvím jako je fve střídač, bojler, tepelné čerpadlo, chytrá zásuvka a jiné.",
  "partnerPortal.title": "Partnerská sekce",
  "portalExit.close": "Zavřít",
  "portalExit.text": "Došlo k odpojení od zařízení. Zařízení buď nemá přístup k internetu, nebo na něm došlo k chybě.",
  "portalExit.title": "Zařízení není dostupné",
  "portalVisits.active": "Aktivní",
  "portalVisits.device": "Zařízení",
  "portalVisits.empty": "Zatím nejsou zaznamenány žádné návštěvy.",
  "portalVisits.endedAt": "Konec",
  "portalVisits.ongoing": "Probíhá",
  "portalVisits.partner": "Partner",
  "portalVisits.startedAt": "Začátek",
  "portalVisits.summary.device": "Za posledních {days} dní: {visits, plural, one {# návštěva} few {# návštěvy} other {# návštěv}} · {visitors, plural, one {# uživatel} few {# uživatelé} other {# uživatelů}} · {duration}. Zobrazeno posledních {count} návštěv.",
  "portalVisits.summary.user": "Za posledních {days} dní: {visits, plural, one {# návštěva} few {# návštěvy} other {# návštěv}} · {devices, plural, one {# zařízení} other {# zařízení}} · {duration}. Zobrazeno posledních {count} návštěv.",
  "portalVisits.title": "Používání portálu",
  "portalVisits.user": "Uživatel",
  "searchField.clear": "Vymazat",
  "searchField.label": "Vyhledat",
  "setInDeviceSettings.tooltip": "Nastaveno v zařízení, pro odebrání navštivte servisní nastavení",
  "stripeCallback.error": "Chyba při zpracování platby. Zkuste to prosím znovu.",
  "stripeCallback.failure": "Vaše platba se nepodařilo zpracovat. Pokud máte nějaké dotazy, kontaktujte nás.",
  "stripeCallback.success": "Děkujeme za vaši platbu. Během pár vteřin platbu zpracujeme a přesměrujeme vás zpět do Infigy.",
  "stripeCallback.title": "Zpracování platby",
  "subscription.transfer.cancel": "Zavřít",
  "subscription.transfer.error": "Nepodařilo se přesunout předplatné",
  "subscription.transfer.submit": "Přesunout",
  "subscription.transfer.success": "Předplatné bylo přesunuto",
  "subscription.transfer.title": "Přesunout předplatné",
  "subscription.transfer.tooltip": "Přesunout předplatné na jiné zařízení",
  "user.changePassword.confirmPassword": "Kontrola nového hesla",
  "user.changePassword.currentPassword": "Současné Heslo",
  "user.changePassword.error": "Nepodařilo se změnit heslo",
  "user.changePassword.incorrectPassword": "Nesprávné heslo",
  "user.changePassword.newPassword": "Nové Heslo",
  "user.changePassword.submit": "Změnit heslo",
  "user.changePassword.success": "Heslo změněno",
  "user.confirmEmail.button": "Potvrdit ručně",
  "user.confirmEmail.cancel": "Zrušit",
  "user.confirmEmail.confirm": "Potvrdit",
  "user.confirmEmail.confirmTitle": "Opravdu chcete ručně potvrdit email {email}?",
  "user.confirmEmail.error": "Nepodařilo se potvrdit email",
  "user.confirmEmail.success": "Email byl potvrzen",
  "user.create.button": "Vytvořit uživatele",
  "user.create.cancel": "Zavřít",
  "user.create.emailLabel": "Email",
  "user.create.error": "Nepodařilo se vytvořit uživatele",
  "user.create.info": "Uživateli bude poslaná pozvánka s odkazem na nastavení hesla.",
  "user.create.submit": "Vytvořit",
  "user.create.success": "Uživatel byl vytvořen",
  "user.create.title": "Vytvořit uživatele",
  "user.detail.createdAt": "Vytvořen",
  "user.detail.deviceInternalIp": "Interní IP",
  "user.detail.deviceName": "Jméno",
  "user.detail.deviceStatus": "Status",
  "user.detail.devices": "Zařízení",
  "user.detail.email": "Email",
  "user.detail.emailConfirmed": "Email potvrzen",
  "user.detail.groupEmail": "E-mail",
  "user.detail.groupName": "Jméno",
  "user.detail.groupUpdatedAt": "Upraveno",
  "user.detail.groups": "Skupiny",
  "user.detail.invitedAt": "Pozván",
  "user.detail.locale": "Jazyk",
  "user.locale.error": "Nepodařilo se změnit jazyk uživatele",
  "user.locale.success": "Jazyk uživatele změněn",
  "user.locale.unset": "Nenastaveno (podle prohlížeče)",
  "user.passwordReset.button": "Reset Hesla",
  "user.passwordReset.cancel": "Zrušit",
  "user.passwordReset.confirm": "Odeslat",
  "user.passwordReset.confirmContent": "Doporučujeme použít tuto akci, když např. uživatel nemůže najít email s pozvánkou.",
  "user.passwordReset.confirmTitle": "Opravdu chcete poslat uživateli {email} email pro změnu hesla?",
  "user.passwordReset.error": "Nepodařilo se odeslat email",
  "user.passwordReset.success": "Email byl odeslán",
  "user.setPassword.button": "Nastavit heslo",
  "user.setPassword.cancel": "Zavřít",
  "user.setPassword.confirmLabel": "Kontrola hesla",
  "user.setPassword.error": "Nepodařilo se změnit heslo",
  "user.setPassword.info": "Preferovaný způsob změny hesla je poslání odkazu s resetem hesla, resp. použití formuláře \"zapomněl jsem heslo\".",
  "user.setPassword.passwordLabel": "Heslo",
  "user.setPassword.submit": "Nastavit heslo",
  "user.setPassword.success": "Heslo změněno",
  "user.setPassword.title": "Nastavit heslo",
  "user.title": "Uživatel",
  "user.titleSegment": "Uživatel",
  "userDevice.create.cancel": "Zavřít",
  "userDevice.create.error": "Nepodařilo se přidat zařízení",
  "userDevice.create.submit": "Přidat",
  "userDevice.create.success": "Zařízení přidáno",
  "userDevice.create.title": "Přiřadit uživatele k zařízení",
  "userDevice.remove.cancel": "Zrušit",
  "userDevice.remove.confirm": "Odebrat",
  "userDevice.remove.confirmTitle": "Opravdu chcete odebrat zařízení {deviceName} ({deviceId}) od uživatele {email}?",
  "userDevice.remove.error": "Došlo k chybě",
  "userDevice.remove.success": "Zařízení úspěšně odebráno od uživatele",
  "userSelect.label": "Uživatelé",
  "users.table.createdAt": "Vytvořen",
  "users.table.devices": "Zařízení",
  "users.table.email": "Email",
  "users.table.groups": "Skupin",
  "users.table.role": "Role",
  "users.title": "Uživatelé",
  "virtualAddress.copiedAddress": "Adresa zkopírována do schránky",
  "virtualAddress.copiedSsh": "SSH příkaz zkopírován do schránky",
  "virtualAddress.copyAddress": "Zkopírovat adresu",
  "virtualAddress.copySsh": "Zkopírovat SSH příkaz"
}